import styled, { css } from 'styled-components';
import Link from '../../navigation/Link';
import media from '../../../utils/styling/media';

export const StyledFooterLinksWrapper = styled.div<{
  vertical: boolean;
}>`
  display: flex;
  margin:  0 0 36px 0;

  ${media.xs`
    flex-direction: column;
  `}

  ${({ vertical }) => !vertical && css`
    ${media.md`
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 20px;
    `}
  `}

  ${({ vertical }) => vertical && css` 
    ${media.xs`
      & ${Link.StyledLink} {
        color: ${({ theme }) => theme.colors.black};
        font-weight: normal;
      }
    `}
  `}

`;

export const StyledFooterLinks = styled.ul<{
  vertical: boolean;
}>`
  padding: 0;
  list-style: none;
  display: block;
  margin: 0 0 20px 0;

  ${({ vertical }) => !vertical && css`
    ${media.md`
      display: flex;
      flex-wrap: wrap;
      margin: 0;
    `}
  `}
`;

export const StyledFooterLink = styled.li`
  margin: 0 0 24px 0;
  padding: 0;

  ${media.sm`
    margin: 0 0 24px 0;
    margin-right: 32px;
  `}

  ${media.md`
    margin:  0 32px 24px 0;
  `}

  &:last-child {
    margin-right: 0;
  }
`;

export const StyledFooterButtons = styled.div<{
  vertical: boolean;
}>`
  position: relative;
  display: flex;
  top: -4px;


  ${media.xs`
    margin: -12px;
    flex-direction: column;
    align-items: flex-start;

    > * {
      margin: 12px;
    }
  `}

  ${({ vertical }) => !vertical && css`
    ${media.md`
      flex-direction: row;
      margin: -16px;

      > * {
        margin: 16px;
      }
    `}
  `}
`;
